import { useState, useRef } from "react";
import axios from "axios";

export default function SessionLoginModal({ open, onClose, onSuccess }) {
  const [nik, setNik] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef([]);

  const maskId = (id) => {
  if (!id) return "";

  const str = String(id);

  if (str.length <= 3) return str;

  const first = str.slice(0, 2);
  const last = str.slice(-2);
  const middle = "*".repeat(str.length - 4);

  return `${first}${middle}${last}`;
};

const idSunfish = localStorage.getItem("id_sunfish");

  if (!open) return null;

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 5) inputsRef.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) inputsRef.current[index - 1]?.focus();
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      alert("OTP harus 6 digit");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post("/api/login-2fa", {
       id_sunfish: idSunfish,
        otp: otpCode,
      });

      if (res.data.success) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("kode_toko", res.data.kode_toko);
        localStorage.setItem("nama_toko", res.data.nama_toko);
        localStorage.setItem("id_sunfish", res.data.id_sunfish);
        localStorage.setItem("nama", res.data.nama);

        onSuccess?.(res.data);
        onClose?.();
      } else {
        alert(res.data.message || "Login gagal");
      }
    } catch (err) {
      alert(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center">

      {/* BACKDROP (LOCK ONLY, NO CLICK) */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm pointer-events-none" />

      {/* MODAL */}
      <div className="relative z-10 w-full max-w-md mx-4">

        <div className="bg-white rounded-2xl shadow-2xl p-6 text-gray-800 animate-fadeIn">

          {/* HEADER */}
         <div className="text-center mb-5">
  <h2 className="text-xl font-bold text-red-600">Verifikasi Keamanan Diperlukan</h2>
  <p className="text-sm text-gray-600 mt-1">
    Silakan verifikasi ulang menggunakan OTP dari Google Authenticator sebelum melanjutkan
  </p>
</div>
<h1 className="text-center text-3xl font-bold mb-2 tracking-wide">
  <span className="text-gray-900">{maskId(idSunfish)}</span>
</h1>

<p className="text-center text-sm text-gray-600 mb-6 leading-relaxed">
  Masukkan OTP untuk memastikan bahwa kamu adalah pemilik akun dengan NIK di atas
</p>

          {/* FORM */}
          <form onSubmit={handleLogin} className="space-y-4">

            {/* NIK */}
            

            {/* OTP */}
            <div className="flex justify-between gap-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputsRef.current[index] = el)}
                  className="w-12 h-12 text-center text-lg font-bold rounded-xl bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500"
                />
              ))}
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-xl font-semibold bg-red-600 hover:bg-red-700 text-white transition shadow-lg"
            >
              {loading ? "Verifying..." : "Verifikasi"}
            </button>

          </form>

        </div>
      </div>
    </div>
  );
}